<script lang="ts">
  import { AppState } from '../../etc/stores';
</script>

<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
    fill="#FF1E61"
    fill-opacity="0.1"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15.6314 9.43023C15.9242 9.13734 15.9242 8.66247 15.6314 8.36957C15.3385 8.07668 14.8636 8.07668 14.5707 8.36957L12.0005 10.9398L9.43086 8.37011C9.13797 8.07722 8.66309 8.07722 8.3702 8.37011C8.07731 8.663 8.07731 9.13788 8.3702 9.43077L10.9398 12.0004L8.36957 14.5707C8.07668 14.8636 8.07668 15.3385 8.36957 15.6314C8.66247 15.9242 9.13734 15.9242 9.43023 15.6314L12.0005 13.0611L14.5713 15.6319C14.8642 15.9248 15.3391 15.9248 15.632 15.6319C15.9249 15.339 15.9249 14.8641 15.632 14.5712L13.0612 12.0004L15.6314 9.43023Z"
    fill="#FF1E61"
  />
</svg>
